export const companyInfo = {
  name: "Shree Balaji Corporation",
  tagline: "Serving cotton pressing and ginning industries with premium-quality PET straps, bale covers, washers, and strapping machines.",
  description: "Specialized supplier of PET straps, bale covers, leather washers, and strapping machines for cotton ginning and pressing industries.",
  email: "ashushah1977@yahoo.com",
  phone: '+91-9422161161',
  phone2: "+91-63422 22222",
  whatsapp: "+91-9764166071",
  address: "50, Midc Phase 3 and 4, MIDC, Akola, Shivar, Maharashtra 444104, India"
};

export const productCategories = [
  {
    id: 1,
    name: "PET Straps",
    description: "High-quality PET straps specifically designed for cotton bale packaging",
    image: "/assets/products/pet-straps/category-cover.jpg",
    products: [
      {
        id: 101,
        name: "PET Strap for Cotton Bales",
        price: 80,
        unit: "Roll",
        minOrder: 10,
        size: "Width 16mm",
        color: "Green",
        image: "/assets/products/pet-straps/pet-strap.jpg",
        description: "Premium quality PET straps, polyester strapping bands ideal for cotton bale packaging, agricultural produce binding, and textile industry applications. These eco-friendly plastic strapping rolls offer excellent tensile strength, weather resistance, and durability for cotton ginning mills, pressing mills, and agricultural storage facilities. Compatible with pneumatic strapping machines and manual strapping tools, suitable for outdoor storage and transportation of cotton bales across Maharashtra cotton belt regions.",
        features: [
          "High Tensile Strength for Secure Packaging", 
          "Cotton Industry Specific Design", 
          "Eco-Friendly Recyclable Material",
          "Weather Resistant for Outdoor Storage",
          "Compatible with Pneumatic Tools",
          "Cost-Effective Bulk Packaging Solution"
        ],
        specifications: {
          width: "16mm precision cut",
          material: "PET - 100% Recyclable Polyester",
          color: "Industrial Green",
          application: "Cotton Bales, Agricultural Produce",
          tensileStrength: "High Grade Industrial",
          weatherResistance: "UV and Moisture Resistant"
        }
      },
      {
        id: 102,
        name: "PET Roll Strap for Ginning Mills",
        price: 75,
        unit: "Kilogram",
        minOrder: 500,
        size: "16mm Industrial Grade",
        brand: "Green Industrial",
        image: "/assets/products/pet-straps/pet-roll-strap.jpg",
        description: "Specialized PET roll straps, polyester strapping tape designed for cotton ginning and pressing industry applications with optimal elongation strength and consistent quality. These industrial-grade plastic strapping materials are perfect for high-volume cotton bale packaging, agricultural produce securing, and textile mill operations. Suitable for automated strapping machines, pneumatic packaging equipment, and bulk packaging applications in cotton processing facilities.",
        features: [
          "Industry-Specific Design for Cotton Mills", 
          "High Tensile Strength and Elongation", 
          "Consistent Quality for Automated Equipment",
          "Bulk Supply for Commercial Operations",
          "Compatible with Industrial Strapping Machines",
          "Economical Solution for High-Volume Packaging"
        ],
        specifications: {
          width: "16mm industrial standard",
          industry: "Cotton ginning, pressing, and textile processing",
          material: "Premium PET Polyester",
          packaging: "Bulk rolls for commercial use",
          compatibility: "Pneumatic and automatic strapping machines"
        }
      }
    ]
  },
  {
    id: 2,
    name: "Bale Covers",
    description: "Premium quality covers for cotton bale protection",
    image: "/assets/products/bale-covers/category-cover.jpg",
    products: [
      {
        id: 201,
        name: "Cotton Bale Cover",
        price: 150,
        unit: "Piece",
        minOrder: 100,
        image: "/assets/products/bale-covers/cotton-cover.jpg",
        description: "High-quality cotton covers designed specifically for bale protection during storage and transportation.",
        features: ["Durable Material", "Weather Resistant", "Perfect Fit"],
        specifications: {
          material: "Premium Cotton",
          usage: "Bale Protection",
          durability: "High"
        }
      },
      {
        id: 202,
        name: "Polyester Bale Cover",
        price: 180,
        unit: "Piece",
        minOrder: 100,
        image: "/assets/products/bale-covers/polyester-cover.jpg",
        description: "Weather-resistant polyester covers providing superior protection for cotton bales.",
        features: ["Weather-Proof", "Long-Lasting", "UV Resistant"],
        specifications: {
          material: "Industrial Polyester",
          protection: "All-Weather",
          durability: "Extended"
        }
      }
    ]
  },
  {
    id: 3,
    name: "Ginning Washer",
    description: "Premium quality leather washers for ginning machines",
    image: "/assets/products/ginning-washers/category-cover.jpg",
    products: [
      {
        id: 301,
        name: "Leather Ginning Washer",
        price: 12,
        unit: "Piece",
        minOrder: 1000,
        material: "Leather",
        image: "/assets/products/ginning-washers/leather-washer.jpg",
        description: "High-grade leather washers specifically designed for cotton ginning machines.",
        features: ["Fine Finish", "Rugged Design", "Long Service Life"],
        specifications: {
          material: "Premium Leather",
          finish: "Fine",
          design: "Industrial Grade"
        }
      }
    ]
  },
  {
    id: 4,
    name: "Pneumatic Tools",
    description: "Professional-grade pneumatic tools for cotton bale packaging",
    image: "/assets/products/pneumatic-tools/category-cover.jpg",
    products: [
      {
        id: 401,
        name: "Pneumatic Plastic Strapping Machine",
        price: 75000,
        unit: "Piece",
        minOrder: 1,
        image: "/assets/products/pneumatic-tools/plastic-strapping.jpg",
        description: "Heavy-duty pneumatic strapping machine designed for cotton bale packaging.",
        features: ["Sturdy Construction", "User Friendly", "Low Maintenance"],
        specifications: {
          type: "Pneumatic",
          material: "Industrial Grade Steel",
          application: "Cotton Bales"
        }
      },
      {
        id: 402,
        name: "Powerful Pneumatic Strapping Machine",
        price: 85000,
        unit: "Piece",
        minOrder: 1,
        image: "/assets/products/pneumatic-tools/powerful-pneumatic.jpg",
        description: "High-performance pneumatic strapping machine for intensive cotton bale packaging operations.",
        features: ["High Performance", "Extended Service Life", "Easy Operation"],
        specifications: {
          type: "Heavy-Duty Pneumatic",
          performance: "Industrial Grade",
          serviceLife: "Extended"
        }
      },
      {
        id: 403,
        name: "Pneumatic Strapping Machine",
        price: 65000,
        unit: "Piece",
        minOrder: 1,
        image: "/assets/products/pneumatic-tools/standard-pneumatic.jpg",
        description: "Reliable and efficient pneumatic strapping machine for regular cotton bale packaging needs.",
        features: ["Reliable Performance", "Cost-Effective", "Easy Maintenance"],
        specifications: {
          type: "Standard Pneumatic",
          maintenance: "Low",
          reliability: "High"
        }
      }
    ]
  },
  {
    id: 5,
    name: "Hoops Iron Roll and Straps",
    description: "Industrial-grade iron hoops and straps for heavy-duty bale packaging",
    image: "/assets/products/hoops-iron/category-cover.jpg",
    products: [
      {
        id: 501,
        name: "Hoop Iron Strapping Roll",
        price: 60,
        unit: "Kilogram",
        minOrder: 100,
        image: "/assets/products/hoops-iron/strapping-roll.jpg",
        description: "Heavy-duty iron strapping rolls for secure cotton bale packaging.",
        features: ["Superior Strength", "Industrial Grade", "Rust Resistant"],
        specifications: {
          material: "High-grade Iron",
          application: "Heavy-duty Bale Packaging",
          finish: "Rust-resistant Coating"
        }
      }
    ]
  }
];

export const formatPrice = (price) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0
  }).format(price);
};

export const getAllProducts = () => {
  return productCategories.flatMap(category =>
    category.products.map(product => ({
      ...product,
      categoryId: category.id,
      categoryName: category.name
    }))
  );
};

export const getProductById = (id) => {
  return getAllProducts().find(product => product.id === parseInt(id));
};

export const getCategoryById = (id) => {
  return productCategories.find(category => category.id === parseInt(id));
};
